import { DashboardSearchFiltersState, DashboardSearchResults } from "@idw-types/state/dashboard-state";

export enum DashboardActionTypes {
    // Search
    SET_DASHBOARD_SEARCH_FILTERS = "SET_DASHBOARD_SEARCH_FILTERS",
    SET_DASHBOARD_SEARCH_RESULTS_LOADING = "SET_DASHBOARD_SEARCH_RESULTS_LOADING",
    SET_DASHBOARD_SEARCH_RESULTS = "SET_DASHBOARD_SEARCH_RESULTS"
}

// Search
type SetDashboardSearchFiltersAction = {
    type: DashboardActionTypes.SET_DASHBOARD_SEARCH_FILTERS;
    payload: { searchFilters: DashboardSearchFiltersState };
};

export const setDashboardSearchFilters = (searchFilters: DashboardSearchFiltersState): SetDashboardSearchFiltersAction => ({
    type: DashboardActionTypes.SET_DASHBOARD_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetDashboardSearchResultsLoadingAction = {
    type: DashboardActionTypes.SET_DASHBOARD_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setDashboardSearchResultsLoading = (isLoading: boolean): SetDashboardSearchResultsLoadingAction => ({
    type: DashboardActionTypes.SET_DASHBOARD_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetDashboardSearchResultsAction = {
    type: DashboardActionTypes.SET_DASHBOARD_SEARCH_RESULTS;
    payload: { searchResults: DashboardSearchResults };
};

export const setDashboardSearchResults = (searchResults: DashboardSearchResults): SetDashboardSearchResultsAction => ({
    type: DashboardActionTypes.SET_DASHBOARD_SEARCH_RESULTS,
    payload: { searchResults }
});

export type DashboardActions =
    // Search
    SetDashboardSearchFiltersAction |
    SetDashboardSearchResultsLoadingAction |
    SetDashboardSearchResultsAction